import ErrorUtils from '~/utils/error_utils';

export default {
    searchUsers(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/organization/user/selector-search',
                type: 'GET',
                data: params,
            }).done((json) => {
                resolve(json);
            }).fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    getDefaultFilterData() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/organization/user/filter-form-json',
                type: 'GET',
                global: false,
            }).done((json) => {
                resolve(json);
            }).fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    gatherBulkEditOptions() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/organization/user/bulk-edit-options-json',
                type: 'GET',
                global: false,
            }).done((json) => {
                resolve(json);
            }).fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    bulkUpdateUserOptions(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/organization/user/bulk-user-update',
                type: 'POST',
                data: params,
                global: false,
            }).done((json) => {
                resolve(json);
            }).fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },

    clearUserTokens(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/organization/user/clear-user-tokens',
                type: 'POST',
                data: params,
                global: false,
            }).done((json) => {
                resolve(json);
            }).fail((xhr) => {
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    }
};
